'use client';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const BaseStack = styled(Stack)();
